const Roles = {
    AdminUser: "AdminUser",
    PracticeUser: "PracticeUser",
}

export default Roles;